module.exports = __webpack_public_path__ + "static/media/freelance_logo.42325d59.png";